// AUTO-GENERATED - DO NOT EDIT MANUALLY

import { hydrateUser, type User, type UserApiResponse } from './user.gen';
import { hydrateActivity, type Activity, type ActivityApiResponse } from './activity.gen';
import { hydrateSession, type Session, type SessionApiResponse } from './session.gen';
import { hydrateBusiness, type Business, type BusinessApiResponse } from './business.gen';
import { hydrateCustomer, type Customer, type CustomerApiResponse } from './customer.gen';
import { hydrateGiftcard, type Giftcard, type GiftcardApiResponse } from './giftcard.gen';
import { hydrateArea, type Area, type AreaApiResponse } from './area.gen';
import { hydrateBooking, type Booking, type BookingApiResponse } from './booking.gen';
import { hydrateBookableGiftcard, type BookableGiftcard, type BookableGiftcardApiResponse } from './bookableGiftcard.gen';
import { hydrateOffer, type Offer, type OfferApiResponse } from './offer.gen';
import { hydrateOfferCollection, type OfferCollection, type OfferCollectionApiResponse } from './offerCollection.gen';

export type ActionTrackingEntityApiResponse =
	| UserApiResponse
	| ActivityApiResponse
	| SessionApiResponse
	| BusinessApiResponse
	| CustomerApiResponse
	| GiftcardApiResponse
	| AreaApiResponse
	| BookingApiResponse
	| BookableGiftcardApiResponse
	| OfferApiResponse
	| OfferCollectionApiResponse;

export type ActionTrackingEntity =
	| User
	| Activity
	| Session
	| Business
	| Customer
	| Giftcard
	| Area
	| Booking
	| BookableGiftcard
	| Offer
	| OfferCollection;

export function hydrateActionTrackingEntity(data: ActionTrackingEntityApiResponse): ActionTrackingEntity {
	if ('preferredLocale' in data) return hydrateCustomer(data as CustomerApiResponse);
	if ('pax' in data) return hydrateBooking(data as BookingApiResponse);
	if ('remainingAmount' in data) return hydrateGiftcard(data as GiftcardApiResponse);
	if ('validityMode' in data) return hydrateBookableGiftcard(data as BookableGiftcardApiResponse);
	if ('timezone' in data) return hydrateBusiness(data as BusinessApiResponse);
	if ('role' in data) return hydrateUser(data as UserApiResponse);
	if ('allowFullOnlinePayment' in data) return hydrateOffer(data as OfferApiResponse);
	if ('offers' in data) return hydrateOfferCollection(data as OfferCollectionApiResponse);
	if ('engine' in data) return hydrateSession(data as SessionApiResponse);
	if ('capacity' in data) return hydrateArea(data as AreaApiResponse);
	return hydrateActivity(data as ActivityApiResponse);
}